import React, { useEffect, useState, useCallback } from "react";
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources } from "../authConfig";
import { HistoricalRecordForm } from "./HistoricalRecordForm";
import Card from '@mui/material/Card';
import { HistoricalRecordGrid } from "./HistoricalRecordGrid";
import LoadingSpinner from "./LoadingSpinner";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const customId = "custom-id-yes";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Button } from "react-bootstrap";
import Collapse from '@mui/material/Collapse';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const HistoricalRecordView = (props) => {

    const [adminData, setAdminData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [showAllEmployees, setShowAllEmployees] = useState(false);
    const [dateFilter, setDateFilter] = useState({ startDate: null, endDate: null });
    const [gridClearFunction, setGridClearFunction] = useState(null);

    const { error, isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.api.scopes
    });

    const toggleFilter = () => setShowFilter(!showFilter);

    useEffect(() => {
        if (!adminData) {
            execute("GET", protectedResources.api.administrator)
                .then((response) => {
                    if (response?.data) {
                        setAdminData(response.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching administrator:", error);
                });
        }
    }, [execute, adminData]);

    const handleDateFilterChange = useCallback((newDateFilter) => {
        setDateFilter(newDateFilter);
    }, []);
    
    const handleGridClearFunction = useCallback((clearFn) => {
        setGridClearFunction(() => clearFn);
    }, []);
    
    const handleCompleteFilterClear = useCallback(() => {
        setDateFilter({ startDate: null, endDate: null });
        
        if (gridClearFunction) {
            gridClearFunction();
        }
    }, [gridClearFunction]);

    if (error) {
        toast.error(error.message, {
            toastId: customId,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
    
    const renderForm = (
        <>
            {adminData?.isAdmin && (
                <Card variant="outlined" className="mb-3">
                    <Button
                        className="filterHeaderButton"
                        onClick={toggleFilter}
                        style={{
                            width: '100%',
                            padding: '10px 16px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: 'none',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                            textAlign: 'left'
                        }}
                    >
                        <span style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                            Filtros
                        </span>
                        <i
                            className={`fa fa-angle-down ${showFilter ? 'rotated' : ''}`}
                            style={{
                                transition: 'transform 0.2s ease',
                                color: 'rgba(0, 0, 0, 0.6)'
                            }}
                        />
                    </Button>
                    <Collapse in={showFilter}>
                        <div style={{ padding: '16px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showAllEmployees}
                                        onChange={(e) => setShowAllEmployees(e.target.checked)}
                                    />
                                }
                                label="Mostrar todos los empleados (no solo mis subordinados)"
                            />
                            <HistoricalRecordForm 
                                onDateFilterChange={handleDateFilterChange} 
                                onClearAllFilters={handleCompleteFilterClear}
                            />
                        </div>
                    </Collapse>
                </Card>
            )}
            <Card variant="outlined">
                <h2 className="tituloH2 mt-3">Histórico de registros</h2>
                <HistoricalRecordGrid
                    showAll={showAllEmployees}
                    isAdmin={adminData?.isAdmin}
                    dateFilter={dateFilter}
                    onClearFilters={handleGridClearFunction}
                />
            </Card>
        </>
    );

    return (
        <div className="container"> {isLoading ? <LoadingSpinner /> : renderForm}</div>
    );
}